import styled from 'styled-components';
import { secondary, black, middleGray, lightGray } from 'styles/colorProvider';

export const Container = styled.div`
  width: 360px;
  min-width: 320px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px;
  border-color: ${(props) => (props.active ? secondary : lightGray)};
  box-shadow: ${(props) => props.active && 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'};

  transition: all 0.3s ease-in-out;
  &&:hover {
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }

  .description {
    display: flex;
    align-items: center;
  }

  div {
    display: flex;
    margin-left: 7% !important;
    width: 100%;
  }

  .iconArrow {
    margin-right: 7%;
  }

  @media (max-width: 1000px) {
    margin-bottom: 20px;
    min-height: 70px;
    margin-left: 0px;
    width: 100%;
    min-width: 100px;
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  height: 60%;
  margin-left: 7%;
`;

export const BrandAndModel = styled.p`
  color: ${black};
  margin: 0;
  font-size: 13px;
`;

export const Plate = styled.p`
  color: ${middleGray};
  font-size: 13px;
  margin: 0;
`;

export const Status = styled.p`
  color: ${(props) => props.color || middleGray};
  font-size: 12px;
  margin: 0;
`;
